import { httpClient } from '@/services/http/httpClient'

type IdeaStatus = {
  waiting: number
  done: number
  paused: number
  review: number
}

type GetDashboardIdeaStatusResponse = {
  ideaStatus: IdeaStatus
  ideaStatusPercent: IdeaStatus
}

export async function getDashboardIdeaStatus(): Promise<GetDashboardIdeaStatusResponse> {
  const { data } = await httpClient.get(`/ideas/ideas/dashboard-status`)

  const ideaStatus = {
    waiting: data?.ideaStatus?.waiting ?? 0,
    done: data?.ideaStatus?.done ?? 0,
    paused: data?.ideaStatus?.paused ?? 0,
    review: data?.ideaStatus?.review ?? 0,
  }

  const ideaStatusPercent = {
    waiting: data?.ideaStatusPercent?.waiting ?? 0,
    done: data?.ideaStatusPercent?.done ?? 0,
    paused: data?.ideaStatusPercent?.paused ?? 0,
    review: data?.ideaStatusPercent?.review ?? 0,
  }

  return {
    ideaStatus,
    ideaStatusPercent,
  }
}
